import React, { useMemo, useEffect, useState } from "react";
import Select from "react-select";
import { getThematicAreas } from "common/services/data-types.service";
import { normalize } from "common/lib/normalize";

type FilterProps = {
  onChange: (value: any) => void;
  value: any;
};
const ThematicAreaFilter = ({ onChange, value }: FilterProps) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor: "#ced4da",
      "&:hover": {
        borderColor: "#ced4da",
      },
    }),
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let filters: any = {};

        const response = await getThematicAreas({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
          filters,
          fields: ["id", "name"],
        });

        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });
  }, [data]);

  return (
    <Select
      name="thematicArea"
      id="thematicArea"
      isSearchable
      isClearable
      placeholder="Select thematic area"
      onChange={onChange}
      options={options}
      value={value}
      styles={customSelectStyles}
      loading={loading}
    />
  );
};

export default ThematicAreaFilter;
